// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

function render1(props) {
  const { container } = props;
  const appTarget = container ? container.querySelector('#root') : document.querySelector('#root');
  appTarget.className = styles.app;
  if (supportedBrowser()) {
    if (Object.keys(props).length > 0) {
      window.qiankunData = {
        canSave: props.canSave,
        fr: props.fr,
        target: props.target,
        projectType: props.projectType,
        role: props.role,
        projectId: props.projectId,
      };
    }
    require('./render-gui.jsx').default(appTarget);
  } else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(
      BrowserModalComponent,
      true /* localesOnly */
    );
    const handleBack = () => {};
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
  }
  
}

// export async function bootstrap() {
//   console.log('react app bootstraped');
// }

// export async function mount(props) {
//   console.log('props from main framework', props);
//   render(props);
// }

// export async function unmount(props) {
//   const { container } = props;
//   ReactDOM.unmountComponentAtNode(
//     container
//       ? container.querySelector('#root')
//       : document.querySelector('#root')
//   );
// }

const appTarget = document.createElement('div');
appTarget.id = 'root'
const container = document.getElementById('scratchEditor');
appTarget.className = styles.app;
if (container) {
  container.appendChild(appTarget);
} else {
  document.body.appendChild(appTarget);
}

let render = null;

if (supportedBrowser()) {
  // require needed here to avoid importing unsupported browser-crashing code
  // at the top levelimport { setIsClass } from '../lib/anti-addiction';
	
  render = (props) => {
		// console.log(props)
		if (Object.keys(props).length > 0) {
      window.qiankunData = {
        canSave: props.canSave,
        fr: props.fr,
        target: props.target,
        projectType: props.projectType,
        role: props.role,
        projectId: props.projectId,
      };
    }
    require('./render-gui.jsx').default(appTarget);
  };
} else {
  BrowserModalComponent.setAppElement(appTarget);
  const WrappedBrowserModalComponent = AppStateHOC(
    BrowserModalComponent,
    true /* localesOnly */
  );
  const handleBack = () => {};
  render = () => {
    ReactDOM.render(
      <WrappedBrowserModalComponent onBack={handleBack} />,
      appTarget
    );
  };

  // eslint-disable-next-line react/jsx-no-bind
}

export async function bootstrap(props) {
  // setIsClass(props.isClass);
  console.log('qiankun bootstrap:', props)
}
export async function mount(props) {
  console.log('qiankun bootstrap:', props);
  render(props);
  // setIsClass(props.isClass);
}
export async function unmount() {
  ReactDOM.unmountComponentAtNode(document.getElementById('root'));
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({
    // canSave: 1,
    // fr: 'community',
    // target: 'community',
    // projectType: 1,
    // projectId: '42374b14fcd3df952ee26bccd5c63c6c',
    // role:1
  });
}